module.exports = __webpack_public_path__ + "assets/80ca66d0836ebaaab888fdb97036af89.png";